import React from 'react';

const Introduction = ({ sectionData, baseUrl }) => {
  if (!sectionData) return null;

  return (
    <>
      {sectionData.map((item, index) => (
        <section key={item.id} className={index % 2 !== 0 ? 'committee-function' : ''}>
          <div className="container">
            {/* Heading */}
            {item.heading && (
              <div className="sec-title text-center">
                <h2>{item.heading}</h2>
              </div>
            )}

            <div className={`row d-flex justify-content-center align-items-center ${item.image_position === 'right' ? 'flex-column-reverse flex-md-row' : ''}`}>
              
              {/* Logic for Left Image Position */}
              {item.image_position === 'left' && item.image && (
                <div className="col-md-4 col-12 mb-3 mb-md-0">
                  <img
                    src={`${baseUrl}/public/${item.image}`}
                    alt={item.heading}
                    className="img-fluid"
                    style={{ borderRadius: "10px" }}
                  />
                </div>
              )}

              {/* Text Content */}
              <div className={item.image ? "col-md-8 col-12" : "col-12"}>
                {/* Textareas */}
                {item.textareas && item.textareas.map((text, i) => (
                  <p key={i} style={{ textAlign: "justify" }}>
                    {text}
                  </p>
                ))}

                {/* List Points */}
                {item.list_points && item.list_points.length > 0 && (
                  <ul className="member-list">
                    {item.list_points.map((point, i) => (
                      <li key={i}>
                        <i className="fa fa-dot-circle-o"></i> {point}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Logic for Right Image Position */}
              {item.image_position === 'right' && item.image && (
                <div className="col-md-4 col-12 mb-3 mb-md-0">
                  <img
                    src={`${baseUrl}/public/${item.image}`}
                    alt={item.heading}
                    className="img-fluid"
                    style={{ borderRadius: "10px" }}
                  />
                </div>
              )}

            </div>
          </div>
        </section>
      ))}
    </>
  );
};

export default Introduction;